import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="財經錢線"
        brandName="財經錢線"
        englishName="FINLINE"
        tagline="財經不是只有數字，也是理解世界的方式。"
      />
      <Footer />
    </>
  );
}

